import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import Layout from "@/components/Layout";
import ProtectedRoute from "@/components/ProtectedRoute";
import { AuthProvider } from "@/context/AuthContext";
import { SettingsProvider } from "@/context/SettingsContext";
import { ThemeProvider } from "@/context/ThemeContext";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Courses from "@/pages/Courses";
import Facilities from "@/pages/Facilities";
import Placements from "@/pages/Placements";
import Careers from "@/pages/Careers";
import Contact from "@/pages/Contact";
import AdminLogin from "@/pages/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminBranding from "@/pages/admin/AdminBranding";
import AdminTheme from "@/pages/admin/AdminTheme";
import AdminHero from "@/pages/admin/AdminHero";
import AdminContent from "@/pages/admin/AdminContent";
import AdminContact from "@/pages/admin/AdminContact";
import AdminCourses from "@/pages/admin/AdminCourses";
import AdminFacilities from "@/pages/admin/AdminFacilities";
import AdminCareers from "@/pages/admin/AdminCareers";

function App() {
  return (
    <div className="App">
      <ThemeProvider>
        <SettingsProvider>
          <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route element={<Layout />}>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/courses" element={<Courses />} />
                <Route path="/facilities" element={<Facilities />} />
                <Route path="/placements" element={<Placements />} />
                <Route path="/careers" element={<Careers />} />
                <Route path="/contact" element={<Contact />} />
              </Route>
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute>
                    <AdminLayout />
                  </ProtectedRoute>
                }
              >
                <Route index element={<AdminDashboard />} />
                <Route path="branding" element={<AdminBranding />} />
                <Route path="theme" element={<AdminTheme />} />
                <Route path="hero" element={<AdminHero />} />
                <Route path="content" element={<AdminContent />} />
                <Route path="contact" element={<AdminContact />} />
                <Route path="courses" element={<AdminCourses />} />
                <Route path="facilities" element={<AdminFacilities />} />
                <Route path="careers" element={<AdminCareers />} />
              </Route>
            </Routes>
          </BrowserRouter>
          <Toaster position="top-right" richColors closeButton />
        </AuthProvider>
      </SettingsProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
